import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

export default function IconReaction({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill={fill} d="M7.509 2.002a.47.47 0 0 1 .5.48.542.542 0 0 1-.5.525A5.009 5.009 0 0 0 3.003 7.99v4.508a.5.5 0 0 0 .5.5H8.01a5.009 5.009 0 0 0 4.983-4.508.542.542 0 0 1 .526-.5.47.47 0 0 1 .479.501A6.01 6.01 0 0 1 8.01 14H3.502C2.672 14 2 13.328 2 12.498V7.99a6.01 6.01 0 0 1 5.509-5.988z"/>
            <path fill={fill} d="M9.535 8.318a.491.491 0 0 1 .627-.32.52.52 0 0 1 .312.652l-.003.01-.006.017a3.005 3.005 0 0 1-.094.229 3.61 3.61 0 0 1-.309.542c-.285.414-.756.908-1.474 1.154a2.86 2.86 0 0 1-1.846-.012 3.366 3.366 0 0 1-.719-.34l-.046-.03-.014-.01-.005-.004-.004-.002a.53.53 0 0 1-.123-.719.484.484 0 0 1 .688-.13l.003.002.022.015a2.404 2.404 0 0 0 .501.235c.337.113.773.174 1.231.016.46-.158.774-.477.98-.776a2.579 2.579 0 0 0 .268-.5l.01-.025.001-.004zM6.01 6.599c.39-.134.811.086.94.492a.781.781 0 0 1-.472.977.738.738 0 0 1-.94-.492.781.781 0 0 1 .473-.977zM8.364 5.79c.39-.135.81.086.94.491a.781.781 0 0 1-.473.978.738.738 0 0 1-.94-.492.781.781 0 0 1 .473-.978zM12 1a.5.5 0 0 1 .5.5v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2h-2a.5.5 0 0 1 0-1h2v-2A.5.5 0 0 1 12 1z"/>
        </svg>
    );
}
